"use strict";
var _appId, _connectionBuilder;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoshChatClient = void 0;
const tslib_1 = require("tslib");
const signalr_1 = require("@microsoft/signalr");
const ChatHub_1 = require("./hubs/ChatHub");
const Config_1 = tslib_1.__importDefault(require("./Config"));
const FoshChatCaching_1 = require("./FoshChatCaching");
const events_1 = tslib_1.__importDefault(require("events"));
class FoshChatClient {
    constructor(appId, getUserMetadataDelegate) {
        _appId.set(this, void 0);
        _connectionBuilder.set(this, void 0);
        this.connectionUrl = '';
        this.connectionState = signalr_1.HubConnectionState.Disconnected;
        this.caching = new FoshChatCaching_1.FoshChatCaching(getUserMetadataDelegate);
        this.chatHub = new ChatHub_1.ChatHub();
        this.eventEmitter = new events_1.default();
        tslib_1.__classPrivateFieldSet(this, _appId, appId);
        tslib_1.__classPrivateFieldSet(this, _connectionBuilder, new signalr_1.HubConnectionBuilder()
            .withAutomaticReconnect({
            nextRetryDelayInMilliseconds: () => 2500
        }));
        this.getWithUrlParams = this.getWithUrlParams.bind(this);
        this.Connect = this.Connect.bind(this);
        this.Disconnect = this.Disconnect.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.deleteConversation = this.deleteConversation.bind(this);
        this.markConversationAsRead = this.markConversationAsRead.bind(this);
        this.deleteMessage = this.deleteMessage.bind(this);
        this.getConversations = this.getConversations.bind(this);
        this.getConversationMessages = this.getConversationMessages.bind(this);
        this.getConversation = this.getConversation.bind(this);
        this.subscribeToPresence = this.subscribeToPresence.bind(this);
        this.unsubscribeFromPresence = this.unsubscribeFromPresence.bind(this);
        this.setUserJwt = this.setUserJwt.bind(this);
        this.getUserJwt = this.getUserJwt.bind(this);
        this.getCallbacks = this.getCallbacks.bind(this);
    }
    // Getters
    get ConnectionState() {
        return this.connectionState;
    }
    get Events() {
        return this.eventEmitter;
    }
    get Connection() {
        return this.chatHub.Connection;
    }
    getWithUrlParams() {
        const url = this.connectionUrl === '' ? Config_1.default.ConnectionUrl : this.connectionUrl;
        return {
            url: `${url}?appId=${tslib_1.__classPrivateFieldGet(this, _appId)}`,
            options: {
                accessTokenFactory: this.getUserJwt,
                transport: signalr_1.HttpTransportType.WebSockets,
                skipNegotiation: true,
                withCredentials: false
            }
        };
    }
    getCallbacks() {
        return {
            presenceUpdate: this.onPresenceUpdate.bind(this),
            messageRecieved: this.onMessageReceived.bind(this),
            messageDeleted: this.onMessageDeleted.bind(this),
            markConversationAsRead: this.onMarkConversationAsRead.bind(this),
            markAllMessagesAsRead: this.onMarkAllMessagesAsRead.bind(this),
            conversationDeleted: this.onConversationDeleted.bind(this)
        };
    }
    // Public Methods
    Connect() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log(this.getUserJwt());
            this.connectionState = signalr_1.HubConnectionState.Connecting;
            this.eventEmitter.emit('connectionStateChanged', this.connectionState);
            try {
                const { url, options } = this.getWithUrlParams();
                this.chatHub.Connection = tslib_1.__classPrivateFieldGet(this, _connectionBuilder).withUrl(url, options).build();
                this.chatHub.Connection.onreconnected(this.onReconnected.bind(this));
                this.chatHub.Connection.onreconnecting(this.onReconnecting.bind(this));
                this.chatHub.Connection.onclose(this.onClose.bind(this));
                this.chatHub.registerCallbacks(this.getCallbacks());
                yield this.Connection.start();
                this.connectionState = signalr_1.HubConnectionState.Connected;
                this.eventEmitter.emit('connectionStateChanged', this.connectionState);
            }
            catch (e) {
                this.chatHub.unregisterCallbacks(this.getCallbacks());
                this.connectionState = signalr_1.HubConnectionState.Disconnected;
                this.eventEmitter.emit('connectionStateChanged', this.connectionState);
                console.log(e);
            }
        });
    }
    Disconnect() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.connectionState = signalr_1.HubConnectionState.Disconnecting;
            this.eventEmitter.emit('connectionStateChanged', this.connectionState);
            yield this.Connection.stop();
            this.chatHub.unregisterCallbacks(this.getCallbacks());
            this.connectionState = signalr_1.HubConnectionState.Disconnected;
            this.eventEmitter.emit('connectionStateChanged', this.connectionState);
        });
    }
    setConnectionUrl(newConnectionUrl) {
        this.connectionUrl = newConnectionUrl;
    }
    getConnectionUrl() {
        return this.connectionUrl;
    }
    setUserJwt(newJwt) {
        this.userJwt = newJwt;
    }
    getUserJwt() {
        var _a;
        console.log('User JWT GET:');
        console.log(this.userJwt);
        return (_a = this.userJwt) !== null && _a !== void 0 ? _a : '';
    }
    sendMessage(conversationId, message) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.Connection.invoke('SendMessage', conversationId, message);
        });
    }
    deleteConversation(conversationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.Connection.invoke('DeleteConversation', conversationId);
        });
    }
    markConversationAsRead(conversationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.Connection.invoke('MarkConversationAsRead', conversationId);
        });
    }
    deleteMessage(conversationId, messageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.Connection.invoke('DeleteMessage', conversationId, messageId);
        });
    }
    markAllMessagesAsRead() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.Connection.invoke('MarkAllMessagesAsRead');
        });
    }
    getConversations(conversationUpdatedAt) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.Connection.invoke('GetConversations', conversationUpdatedAt !== null && conversationUpdatedAt !== void 0 ? conversationUpdatedAt : null);
            let allIds = result.conversations.reduce((all, cur) => {
                cur.userIds.forEach(userId => {
                    if (all.indexOf(userId) === -1) {
                        all = [...all, userId];
                    }
                });
                return all;
            }, []);
            yield this.caching.checkCacheForUserIds(allIds);
            const convertedConversations = result.conversations.map(conversation => {
                const userIdsWithUserMetadatas = conversation.userIds.map((userId) => {
                    const metadata = this.caching.getUserMetadataFromCache(userId);
                    return {
                        userId,
                        user: metadata
                    };
                });
                return {
                    conversationId: conversation.conversationId,
                    createdAt: conversation.createdAt,
                    lastMessage: conversation.lastMessage,
                    unreadMessageCount: conversation.unreadMessageCount,
                    updatedAt: conversation.updatedAt,
                    userIds: userIdsWithUserMetadatas
                };
            });
            return {
                isMoreConversationsAvailable: result.isMoreConversationsAvailable,
                conversations: convertedConversations
            };
        });
    }
    getConversationMessages(conversationId, lastMessageTimestamp) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.Connection.invoke('GetConversationMessages', conversationId, lastMessageTimestamp !== null && lastMessageTimestamp !== void 0 ? lastMessageTimestamp : null);
            let allIds = result.messages.reduce((all, cur) => {
                if (all.indexOf(cur.senderUserId) === -1) {
                    all = [...all, cur.senderUserId];
                }
                return all;
            }, []);
            yield this.caching.checkCacheForUserIds(allIds);
            const convertedMessages = result.messages.map(message => {
                const metadata = this.caching.getUserMetadataFromCache(message.senderUserId);
                return Object.assign(Object.assign({}, message), { user: metadata });
            });
            return Object.assign(Object.assign({}, result), { messages: convertedMessages });
        });
    }
    getConversation(otherUserId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.Connection.invoke('GetConversation', otherUserId);
            yield this.caching.checkCacheForUserIds(result.conversation.userIds);
            const newUserIds = result.conversation.userIds.map((userId) => {
                const metadata = this.caching.getUserMetadataFromCache(userId);
                return {
                    userId,
                    user: metadata
                };
            });
            return {
                conversation: Object.assign(Object.assign({}, result.conversation), { userIds: newUserIds })
            };
        });
    }
    subscribeToPresence(otherUserId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.Connection.invoke('SubscribeToPresence', otherUserId);
        });
    }
    unsubscribeFromPresence(otherUserId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.Connection.invoke('UnsubscribeFromPresence', otherUserId);
        });
    }
    // Event Handlers
    onPresenceUpdate(presenceUpdateData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.caching.checkCacheForUserIds([presenceUpdateData.userId]);
            const userMetadata = this.caching.getUserMetadataFromCache(presenceUpdateData.userId);
            this.eventEmitter.emit('presenceUpdate', Object.assign(Object.assign({}, presenceUpdateData), { user: userMetadata }));
        });
    }
    onMessageReceived(messageRecievedData) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.caching.checkCacheForUserIds([messageRecievedData.senderId]);
            const userMetadata = this.caching.getUserMetadataFromCache(messageRecievedData.senderId);
            this.eventEmitter.emit('messageReceived', Object.assign(Object.assign({}, messageRecievedData), { user: userMetadata }));
        });
    }
    onMessageDeleted(messageDeletedData) {
        this.eventEmitter.emit('messageDeleted', messageDeletedData);
    }
    onMarkConversationAsRead(markConversationAsReadData) {
        this.eventEmitter.emit('markConversationAsRead', markConversationAsReadData);
    }
    onMarkAllMessagesAsRead() {
        this.eventEmitter.emit('markAllMessagesAsRead');
    }
    onConversationDeleted(conversationDeletedData) {
        this.eventEmitter.emit('conversationDeleted', conversationDeletedData);
    }
    // Internal
    onReconnected() {
        this.connectionState = signalr_1.HubConnectionState.Connected;
        this.eventEmitter.emit('connectionStateChanged', this.connectionState);
    }
    onReconnecting() {
        this.connectionState = signalr_1.HubConnectionState.Reconnecting;
        this.eventEmitter.emit('connectionStateChanged', this.connectionState);
    }
    onClose() {
        this.connectionState = signalr_1.HubConnectionState.Disconnected;
        this.eventEmitter.emit('connectionStateChanged', this.connectionState);
    }
}
exports.FoshChatClient = FoshChatClient;
_appId = new WeakMap(), _connectionBuilder = new WeakMap();
//# sourceMappingURL=FoshChatClient.js.map